/**
 * @file     dom-tk/index.js - entrypoint for the DOM Toolkit that ships within dcp-client. Support files
 *                             for this toolkit are served from /assets wherever the dcp-client package
 *                             is installed. We figure this location out based on the location of this
 *                             bundle. This ensures that the necessary support files and this code are
 *                             always at the right version relative to each other.
 *
 *                             Note that the dom-tk does not ship branding/appearance css. That is a
 *                             separate concern and normally handled by dcp-style.css in the CDN.
 *
 * @author   Wes Garland, wes@distributive.network
 * @date     Aug 2025
 */
'use strict';

const env = require('../../common/dcp-env');
if (env.isBrowserPlatform)
{
  const bundlePathTail = '/dcp-client/dist/dcp-client-bundle.js';
  const thisScriptHref = document.currentScript.src;
  exports.assetsHref = thisScriptHref.replace(bundlePathTail, '/dcp-client/assets/');
  exports.modals = require('./modals');
}

